<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING BRAND</h1>
      <button class="create-button" @click="onOpenModal">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(platformName)="data">
          <span v-if="!data.item.isInstagram">{{ data.item.platformName }}</span>
          <div v-else>
            <span class="d-block">{{ data.item.platformName }}</span>
            <span>Instagram</span>
          </div>
        </template>

        <template v-slot:cell(pageName)="data">
          <span class="d-block"> {{ data.item.platformId == 4 ? "FB:" : "" }} {{ data.item.pageName }} </span>
          <span v-if="data.item.isInstagram"> IG: {{ data.item.instagramName }} </span>
        </template>
        <template v-slot:cell(platformId)="data">
          <div class="d-flex justify-content-center">
            <img v-if="data.item.platformId == 1" src="@/assets/icons/line.png" class="mx-2" width="40" />
            <img
              v-else-if="data.item.platformId == 4"
              src="@/assets/icons/facebook.png"
              class="mx-2"
              width="40"
            />
            <img
              v-if="data.item.platformId == 5 || data.item.isInstagram"
              src="@/assets/icons/instagram.png"
              class="mx-2"
              width="40"
            />
          </div>
        </template>
        <template v-slot:cell(isActive)="data">
          <span v-if="data.item.isActive" class="text-success">Active</span>
          <span v-else class="text-danger">Inactive</span>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item)" :disabled="![1].includes(data.item.platformId)">
              <font-awesome-icon icon="pencil-alt" class="text-warning" title="Edit" />
            </b-link>
            <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon icon="trash-alt" class="text-danger" title="Delete" />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col class="form-inline justify-content-center justify-content-sm-between">
          <div v-if="rows > 0" class="my-auto">{{ rows }} entires</div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
    <ModalCreatePlatform
      :platformIdList="platformIdList"
      @handleLINE="handleLINE"
      ref="modalCreatePlatform"
      @reloadData="reloadData"
    />
    <ModalConnectLineChannel ref="modalConnectLineChannel" @reloadData="reloadData" />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreatePlatform from "./components/ModalCreatePlatform.vue";
import ModalConnectLineChannel from "./components/ModalConnectLineChannel.vue";
export default {
  name: "SettingTime",
  components: {
    ModalAlertConfirm,
    ModalAlertError,
    ModalCreatePlatform,
    ModalConnectLineChannel,
  },
  data: function() {
    return {
      modalMessage: "",
      bodyDelete: {
        platformId: 0,
        channelId: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      platformIdList: [],
      fields: [
        {
          key: "platformName",
          label: "Channel Name",
          class: "w-100px",
        },
        {
          key: "pageName",
          label: "Page",
          class: "w-100px",
          tdClass: "text-left",
        },
        {
          key: "platformId",
          label: "Platform",
          class: "w-100px",
        },
        {
          key: "isActive",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      items: [],
    };
  },

  created: async function() {
    await this.getList();
  },
  methods: {
    getList: async function() {
      this.platformIdList = [];
      this.isBusy = true;
      await this.axios.get(`${this.$baseUrl}/system/platformlist`).then((data) => {
        if (data.result == 1) {
          this.items = data.detail;
          this.rows = data.detail.length;
          this.items.forEach((ele) => {
            this.platformIdList.push(ele.platformId);
            if (ele.isInstagram) this.platformIdList.push(5);
          });
        }
      });
      this.isBusy = false;
    },
    onOpenModal() {
      this.$refs.modalCreatePlatform.showModal = true;
    },
    handleLINE() {
      this.$refs.modalConnectLineChannel.onShowModal();
    },
    onEdit(item) {
      this.$refs.modalConnectLineChannel.onShowModal(item);
    },
    onDeleteModal(data) {
      this.bodyDelete.platformId = data.platformId;
      this.bodyDelete.channelId = data.channelConfigId;
      this.modalMessage = `คุณต้องการลบ ${data.pageName} ใช่หรือไม่?`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/system/lineconfig/${this.bodyDelete.platformId}/${this.bodyDelete.channelId}`)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", { isShow: true, msg: data.message });
            this.reloadData();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", { isShow: true, msg: data.message });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", { isShow: true, msg: err.message });
        });
    },
    async reloadData() {
      await this.getList();
      this.$refs.modalCreatePlatform.showModal = false;
    },
  },
};
</script>
